var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-title',[[_c('base-goto',_vm._b({},'base-goto',_vm.$attrs,false),[_vm._t("default")],2)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }